import apiClient from './api';
import type { TenantSettings } from '@/types/auth.types';

export interface CreateTenantPayload {
  name: string;
  tenant_code: string;
}

export interface TenantResponse {
  id: string;
  tenant_code: string;
  name: string;
  subscription_status?: string | null;
  settings?: TenantSettings | null;
}

export interface UpdateTenantPayload {
  name?: string;
  subscription_status?: string | null;
  subscription_type?: string | null;
  settings?: TenantSettings | null;
}

export const tenantService = {
  createTenant: async (payload: CreateTenantPayload) => {
    const response = await apiClient.post('/api/admin/tenants', payload);
    return response.data;
  },
  getTenants: async (): Promise<TenantResponse[]> => {
    const response = await apiClient.get<TenantResponse[]>('/api/admin/tenants');
    return response.data;
  },
  updateTenant: async (tenantId: string, payload: UpdateTenantPayload): Promise<TenantResponse> => {
    const response = await apiClient.patch<TenantResponse>(
      `/api/admin/tenants/${tenantId}`,
      payload
    );
    return response.data;
  },
};
